let MiniSceneAnim = {}
let BIRD_APPEAR_INTERVAL = 25 * 1000
let BIRD_MOVE_OFFSETY = 360
let BIRD_OUTSCREEN_OFFSETX = 150
MiniSceneAnim.createBirds = function(miniSceneNode) {
    let self = this
    self.birdContainer = cc.Node.create()
    self.birdContainer.width = 900
    self.birdContainer.height = 900
    // self.birdContainer = cc.LayerColor.create(cc.color(255, 255, 0, 100), 900, 900)
    miniSceneNode.addChild(self.birdContainer, MiniHomeSceneLayerDef.kBirds)
    let plist = "homeConfig/homeAnim_birds.plist"
    self.loadRes(plist, plist, () => {
        if (!self.birds) {
            self.birds = require("clover/scene/component/homescene/homeSceneAnim/BirdFlock").create()
        }
    })
}
MiniSceneAnim.playBirdAnim = function (miniSceneNode) {
    let self = this
    if (self.birdAnimPlayed) {
        return
    }
    self.birdAnimPlayed = true
    MiniSceneAnim.createBirds(miniSceneNode)
    self.birdAction = miniSceneNode.runAction(cc.RepeatForever.create(cc.Sequence.create(cc.DelayTime.create(2), cc.CallFunc.create(() => {
        self.updateBirds()
    }))))
}

MiniSceneAnim.lastBirdAppearTime = 0
MiniSceneAnim.updateBirds = function () {
    let self = this
    if (Localhost.time() - self.lastBirdAppearTime > BIRD_APPEAR_INTERVAL && !self.hasBirdOnMap) {
        function callback() {
            self.hasBirdOnMap = true
            let container_y = -math.random(100, 300)
            self.lastBirdAppearTime = Localhost.time()
            let isFlipX = math.random(100) > 50
            let isFlipY = false
            let winSize = cc.Director.getInstance().getWinSize()
            let birds = self.birds;
            birds.setScaleX(isFlipX && -1 || 1)
            let startPosX
            let destPosX
            if (isFlipX) {
                startPosX = -BIRD_OUTSCREEN_OFFSETX
                destPosX = winSize.width + BIRD_OUTSCREEN_OFFSETX + 50
            } else {
                startPosX = winSize.width + BIRD_OUTSCREEN_OFFSETX
                destPosX = -BIRD_OUTSCREEN_OFFSETX - 50
            }
            let startPosY
            let destPosY
            if (isFlipY) {
                startPosY = container_y + BIRD_MOVE_OFFSETY + math.random(winSize.height - BIRD_MOVE_OFFSETY)
                destPosY = startPosY - BIRD_MOVE_OFFSETY
            } else {
                startPosY = container_y + math.random(winSize.height - BIRD_MOVE_OFFSETY)
                destPosY = startPosY + BIRD_MOVE_OFFSETY
            }
            birds.setPosition(startPosX, startPosY)
            self.birdContainer.addChild(birds)

            birds.runAction(cc.Sequence.create(
                cc.MoveTo.create(15, cc.p(destPosX, destPosY)), cc.CallFunc.create(function () {
                    //cc.log("cc.MoveTo.create")
                    self.hasBirdOnMap = false
                }))
            )
        }
        if (self.birds) {
            callback()
        }
    }
}

let scale = cc.winSize.height / 1208
let MiniSceneWaterAnimConfig = [
    cc.p(200, 100 * scale),
    cc.p(360, 150 * scale),
    cc.p(600, 450 * scale),
    cc.p(220, 900 * scale),
    cc.p(550, 940 * scale),
    cc.p(340, 1000 * scale)
]
let IslandPanelWaterAnimConfig = [
    cc.p(200, 200 * scale)
]
MiniSceneAnim.playHomeSceneWaterAnim = function (miniSceneNode) {
    MiniSceneAnim.playWaterAnim(miniSceneNode, MiniSceneWaterAnimConfig, true)
}
MiniSceneAnim.playIslandWaterAnim = function (islandPanel) {
    MiniSceneAnim.playWaterAnim(islandPanel, IslandPanelWaterAnimConfig)
}
let waterSpriteList = []
MiniSceneAnim.playWaterAnim = function (parentNode, waterConfig, cache) {
    let self = this
    let plist = "homeConfig/homescene_light.plist"
    self.loadRes(plist, plist, function () {
        for (let index = 0; index < waterConfig.length; index++) {
            let sprite = MiniSceneAnim.createWaterAnim()
            sprite.setScale(math.random(50, 130) / 100)
            sprite.setOpacity(math.random(120, 255))
            sprite.setPosition(waterConfig[index])
            if (cache)
                waterSpriteList.push(sprite)
            parentNode.addChild(sprite, MiniHomeSceneLayerDef.kLights)
            function playAnim() {
                self.waterAniId = setTimeout(() => {
                    sprite.play(sprite._animate, math.random(0, 3), math.random(1, 3), () => {
                        playAnim()
                    }, false)
                }, Math.random() * 3000);
            }
            playAnim()
        }
    })
}
MiniSceneAnim.createWaterAnim = function () {
    let sprite = cc.Sprite.createWithSpriteFrameName("homescene_light_0000.png")
    let frames = SpriteUtil.buildFrames("homescene_light_%04d.png", 0, 60)
    let animate = SpriteUtil.buildAnimate(frames, 1 / 30)
    sprite._animate = animate;
    return sprite
}

let miniSceneFishAnimConfig = [
    cc.p(100, 400 * scale),
    cc.p(250, 100 * scale)
]
MiniSceneAnim.playMiniSceneFishAnim = function (miniSceneNode, cache) {
    MiniSceneAnim.playFishAnim(miniSceneNode, miniSceneFishAnimConfig, cache)
}
let finishSpriteList = []
MiniSceneAnim.playFishAnim = function (parentNode, animConfig = {}, cache = false) {
    let self = this
    let plist = "cocos/homeAnim_fish.plist"
    self.loadRes(plist, plist, () => {
        let index = 0
        function createFish() {
            if (index >= animConfig.length) {
                return
            }
            let fish = require("clover/scene/component/homescene/homeSceneAnim/FishSchool").create()
            if (cache){
                finishSpriteList.push(fish)
            }
            parentNode.addChild(fish, MiniHomeSceneLayerDef.kFishs)
            fish.setPosition(animConfig[index])
            index ++
            setTimeout(() => {
                createFish()
            }, Math.random() * 1000 + 1000);
        }
        createFish()
    })
}

let plistLoadingStatus = {}
const plistLoadingStatusEnum = {
    notStart : 0,
    loading : 1,
    loaded  : 2,
    failed  : 3
}
MiniSceneAnim.loadRes = function (resList, key, callback) {
    let falg = plistLoadingStatus[key] || plistLoadingStatusEnum.notStart
    switch (falg) {
        case plistLoadingStatusEnum.notStart:
        case plistLoadingStatusEnum.failed:
            plistLoadingStatus[key] = plistLoadingStatusEnum.loading
            preloadWithLoading(resList, () => {
                plistLoadingStatus[key] = plistLoadingStatusEnum.loaded
                callback && callback()
            }, () => {
                plistLoadingStatus[key] = plistLoadingStatusEnum.failed
            }, () => {
                plistLoadingStatus[key] = plistLoadingStatusEnum.failed
            }, false)
            break;
        case plistLoadingStatusEnum.loading:
            // 在资源加载的时候如果重复调用会导致创建多个
            break;
        case plistLoadingStatusEnum.loaded:
            callback && callback()
            break;
    }
}

MiniSceneAnim.unloadAnim = function(miniSceneNode){
    let self = this
    if (self.birds){
        self.birds.stopAllActions()
    }
    if (self.birdAction){
        miniSceneNode.stopAction(self.birdAction)
    }
    if (self.birdContainer){
        self.birdContainer.removeFromParent()
    }
    ResManager.release([
        "homeConfig/homeAnim_birds.plist",
        "cocos/homeAnim_fish.plist",
        "homeConfig/homescene_light.plist"
    ])
    plistLoadingStatus = {}
    if (self.waterAniId){
        clearTimeout(self.waterAniId)
    }
    let waterSpriteLen = $len(waterSpriteList)
    for (let i = 0; i < waterSpriteLen; ++i){
        if (waterSpriteList[i]){
            waterSpriteList[i].removeFromParent()
        }
    }
    waterSpriteList = []

    let finishSpriteLen = $len(finishSpriteList)
    for (let i = 0; i < finishSpriteLen; ++i){
        if (finishSpriteList[i]){
            finishSpriteList[i].removeFromParent()
        }
    }
    finishSpriteList = []
}
module.exports = MiniSceneAnim